import React, { createContext, useContext } from 'react';
import { SortConfig } from '../Components/types';
import useOperationSort from '../Components/hooks/useOperationSort';

interface OperationSortContextType {
  sorts: SortConfig[];
  setSort: (sorts: SortConfig[]) => void;
}

const OperationSortContext = createContext<
  OperationSortContextType | undefined
>(undefined);

export const OperationSortProvider: React.FC<{
  storageKey: string;
  children: React.ReactNode;
}> = ({ storageKey, children }) => {
  const sortState = useOperationSort(storageKey);

  return (
    <OperationSortContext.Provider value={sortState}>
      {children}
    </OperationSortContext.Provider>
  );
};

export const useOperationSortContext = () => {
  const context = useContext(OperationSortContext);
  if (!context) {
    throw new Error(
      'useOperationSortContext must be used within OperationSortProvider'
    );
  }
  return context;
};
